<nav class="bottom-nav md:hidden" [class.garbage-mode]="appMode.isGarbage()">
  @if (isAuthenticated$ | async) {
    <a routerLink="/map" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="bottom-nav-item">
      <i class="pi pi-map"></i>
      <span>Hartă</span>
    </a>
    @if (appMode.isNature()) {
      <a routerLink="/atlas" routerLinkActive="active" class="bottom-nav-item">
        <i class="pi pi-book"></i>
        <span>Atlas</span>
      </a>
    }
    <a [routerLink]="appMode.isNature() ? '/observations' : '/garbage'" routerLinkActive="active" class="bottom-nav-item">
      <i [class]="appMode.isNature() ? 'pi pi-eye' : 'pi pi-list'"></i>
      <span>{{ appMode.isNature() ? 'Observații' : 'Rapoarte' }}</span>
    </a>
    <a routerLink="/events" routerLinkActive="active" class="bottom-nav-item">
      <i class="pi pi-calendar"></i>
      <span>Evenimente</span>
    </a>
    <a routerLink="/profile" routerLinkActive="active" class="bottom-nav-item">
      <i class="pi pi-user"></i>
      <span>Cont</span>
    </a>
    @if (isAdmin$ | async) {
      <a routerLink="/admin" routerLinkActive="active" class="bottom-nav-item">
        <i class="pi pi-cog"></i>
        <span>Setări</span>
      </a>
    }
  } @else {
    <a routerLink="/harta" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="bottom-nav-item">
      <i class="pi pi-map"></i>
      <span>Hartă</span>
    </a>
    <a routerLink="/despre" routerLinkActive="active" class="bottom-nav-item">
      <i class="pi pi-info-circle"></i>
      <span>Despre</span>
    </a>
    <a routerLink="/auth" routerLinkActive="active" class="bottom-nav-item">
      <i class="pi pi-sign-in"></i>
      <span>Cont</span>
    </a>
  }
</nav>
